import { React, useEffect } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createMetal,
  getAMetal,
  resetState,
  updateAMetal,
} from "../features/metal/metalSlice";

let schema = yup.object().shape({
  metal_name: yup.string().required("Metal Name is Required"),
});

const Addmetal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const getMetalId = location.pathname.split("/")[3];
  const newMetal = useSelector((state) => state.metal);
  const {
    isSuccess,
    isError,
    isLoading,
    createdMetal,
    metalName,
    updatedMetal,
  } = newMetal;

  useEffect(() => {
    if (getMetalId !== undefined) {
      dispatch(getAMetal(getMetalId));
    } else {
      dispatch(resetState());
    }
  }, [getMetalId]);

  useEffect(() => {
    if (isSuccess && createdMetal) {
      toast.success("Metal Added Successfullly!");
            navigate("/admin/list-metal");
      dispatch(resetState());
    }
    if (isSuccess && updatedMetal) {
      toast.success("Metal Updated Successfullly!");
      navigate("/admin/list-metal");
      dispatch(resetState());
    }

    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading, createdMetal, updatedMetal, navigate, dispatch]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      metal_name: metalName || "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (getMetalId !== undefined) {
        const data = { id: getMetalId, metalData: values };
        dispatch(updateAMetal(data));
      } else {
        dispatch(createMetal(values));
        formik.resetForm();
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4 title">
        {getMetalId !== undefined ? "Edit" : "Add"} Metal
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <div>
            <label className="form-label" htmlFor="metal_name">
              Metal Name <span className="text-danger">*</span>
            </label>
            <CustomInput
              type="text"
              name="metal_name"
              onChng={formik.handleChange("metal_name")}
              onBlr={formik.handleBlur("metal_name")}
              val={formik.values.metal_name}
              label="Enter Metal"
              id="metal_name"
            />
            <div className="error">
              {formik.touched.metal_name && formik.errors.metal_name}
            </div>
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
          >
            {getMetalId !== undefined ? "Edit" : "Add"} Metal
          </button>
        </form>
      </div>
    </div>
  );
};

export default Addmetal;
